import React from 'react';
import { useHistory } from 'react-router-dom';

import IconBack from '../../../assets/img/icon-back.svg';
import IconCloseWhite from '../../../assets/img/icon-close-white.svg';
import { useIsMobile } from '../../../hooks';
import { redirectToFundPortal } from '../../../util/helpers';
import { ClickableImage, HeaderLogo } from '../../index';
import { EnrollProgressBarData } from '../ProgressBar/ProggressBar.types';

import styles from './EnrollHeaderLite.module.scss';

type Props = {
  className?: string;
  visibleProgressBar?: boolean;
  showBackButton?: boolean;
  progressBarData?: EnrollProgressBarData
  isParentInitialised?: boolean;
  handleBackBtnPress: ()=>void;
}

const EnrollHeaderLite = (props: Props) => {
  const {
    className,
    handleBackBtnPress,
    progressBarData,
    showBackButton = true,
    visibleProgressBar = false,
    isParentInitialised,
  } = props;
  const isMobile = useIsMobile();

  const history = useHistory();

  return (
    <div className={[styles.wrapper, className].join(' ')}>
      <div className={styles.contentWrapper}>
        {
          !isMobile && <HeaderLogo alaricBgLogo />
        }
        {(visibleProgressBar && isParentInitialised) && (
          <>
            {isMobile && showBackButton && (
              <ClickableImage
                alt=""
                src={IconBack}
                className={styles.backIcon}
                onClick={handleBackBtnPress}
              />
            )}
            <ClickableImage
              alt=""
              src={IconCloseWhite}
              className={styles.closeIcon}
              onClick={redirectToFundPortal}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default EnrollHeaderLite;
